module.exports = __webpack_public_path__ + "transport.bbf33799edca0ffaee2d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/transport/webfont/transport.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/transport/webfont/transport.ttf
// module chunks = styles